import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementGooglepayIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<g clipPath="url(#clip0_7586_53671)">
				<path
					d="M11.3441 11.88V14.646H10.4441V7.806H12.7831C13.3531 7.806 13.8931 8.014 14.3131 8.401C14.7331 8.758 14.9431 9.293 14.9431 9.858C14.9431 10.423 14.7331 10.929 14.3131 11.315C13.8931 11.702 13.3831 11.91 12.7831 11.91L11.3431 11.88H11.3441ZM11.3441 8.639V11.018H12.8441C13.1741 11.018 13.5041 10.899 13.7141 10.661C14.1941 10.215 14.1941 9.472 13.7441 9.025L13.7141 8.995C13.4741 8.757 13.1741 8.608 12.8441 8.638H11.3441V8.639ZM17.0121 9.828C17.6721 9.828 18.1821 10.006 18.5721 10.363C18.9621 10.72 19.1421 11.196 19.1421 11.79V14.645H18.3021V13.991H18.2721C17.9121 14.526 17.4021 14.794 16.8021 14.794C16.2021 14.794 15.8421 14.645 15.4821 14.348C15.1521 14.051 14.9421 13.634 14.9421 13.188C14.9421 12.742 15.1221 12.326 15.4821 12.028C15.8421 11.731 16.3521 11.612 16.9521 11.612C17.5521 11.612 17.9121 11.701 18.2421 11.909V11.701C18.2421 11.404 18.1221 11.106 17.8821 10.928C17.6421 10.72 17.3421 10.601 17.0121 10.601C16.5021 10.601 16.1121 10.809 15.8421 11.226L15.0621 10.75C15.5421 10.126 16.1721 9.828 17.0111 9.828H17.0121ZM15.8731 13.218C15.8731 13.456 15.9931 13.664 16.1731 13.783C16.3831 13.932 16.6231 14.021 16.8631 14.021C17.2231 14.021 17.5831 13.872 17.8531 13.605C18.1531 13.337 18.3031 13.01 18.3031 12.653C18.0331 12.445 17.6431 12.326 17.1331 12.326C16.6231 12.326 16.4731 12.415 16.2331 12.594C15.9931 12.743 15.8731 12.951 15.8731 13.219V13.218ZM24.0001 9.977L21.0311 16.727H20.1311L21.2411 14.378L19.2921 10.007H20.2521L21.6621 13.367H21.6921L23.0721 10.007H24.0021V9.977H24.0001Z"
					fill="currentColor"
				/>
				<path
					d="M7.77507 11.285C7.77507 11.017 7.74507 10.75 7.71507 10.482H3.96607V11.999H6.09507C6.00507 12.475 5.73507 12.921 5.31507 13.188V14.169H6.60507C7.35507 13.485 7.77507 12.475 7.77507 11.285Z"
					fill="currentColor"
				/>
				<path
					d="M3.96601 15.121C5.04601 15.121 5.94507 14.764 6.60507 14.169L5.31507 13.188C4.95507 13.426 4.50501 13.575 3.96501 13.575C2.94501 13.575 2.04601 12.891 1.74601 11.939H0.427007V12.95C1.11701 14.288 2.46601 15.121 3.96601 15.121Z"
					fill="currentColor"
				/>
				<path
					d="M1.74702 11.939C1.56702 11.463 1.56702 10.928 1.74702 10.422V9.41101H0.427017C-0.142983 10.511 -0.142993 11.82 0.427007 12.95L1.74702 11.939Z"
					fill="currentColor"
				/>
				<path
					d="M3.93305 8.817C4.50305 8.817 5.04305 9.025 5.46305 9.412L6.60305 8.282C5.88305 7.628 4.92405 7.241 3.96405 7.271C2.46405 7.271 1.08505 8.104 0.425054 9.442L1.74505 10.453C2.01505 9.50101 2.91505 8.817 3.93405 8.817H3.93305Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7586_53671">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

PaiementGooglepayIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementGooglepayIcon;
